import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const BG     = "#030014";
const BG2    = "#0F0728";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";
const R      = "14px";

const ServicesGrid = ({ title, subtitle, services }) => (
  <Box sx={{ py: { xs: 10, md: 13 }, borderBottom: `1px solid ${LINE}`, background: BG }}>
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
        viewport={{ once: true }}
      >
        <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 1.75 }}>
          {subtitle || "What We Offer"}
        </Typography>
        <Typography sx={{
          fontFamily: "'IBM Plex Serif', serif",
          fontSize: { xs: "1.75rem", md: "2.5rem" },
          fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
          color: INK, maxWidth: 720, mb: 6,
        }}>
          {title}
        </Typography>
      </motion.div>

      <Grid container spacing={2}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: (index % 3) * 0.07 }}
              viewport={{ once: true }}
              style={{ height: "100%" }}
            >
              <Box sx={{
                p: "22px 24px", height: "100%",
                background: BG2, border: `1px solid ${LINE}`, borderRadius: R,
                transition: "border-color 0.2s, transform 0.2s",
                "&:hover": { borderColor: `${ACCENT}60`, transform: "translateY(-2px)" },
              }}>
                {/* Icon */}
                <Box sx={{
                  width: 48, height: 48, borderRadius: "10px", mb: 2.5,
                  background: `rgba(226,104,74,0.12)`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: ACCENT,
                }}>
                  {service.icon}
                </Box>

                <Typography sx={{ fontWeight: 600, color: INK, mb: 0.75, fontSize: "16px" }}>
                  {service.title}
                </Typography>
                <Typography sx={{ color: INK2, fontSize: "14px", lineHeight: 1.65 }}>
                  {service.description}
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default ServicesGrid;
